
export default function volumeIcon(props) {
  return (
    <svg
      {...props}
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      width="22.229"
      height="22.857"
      viewBox="0 0 980.000000 840.000000"
      preserveAspectRatio="xMidYMid meet"
    >
      <g
        transform="translate(0.000000,840.000000) scale(0.100000,-0.100000)"
        fill="#fff"
        stroke="none"
      >
        <path
          d="M5632 8375 c-50 -22 -198 -143 -672 -549 l-205 -176 -165 170 c-91
                    93 -178 174 -193 179 -16 6 -52 11 -81 11 -73 0 -96 -18 -376 -295 l-235 -233
                    -313 -7 c-401 -9 -404 -9 -494 -71 -128 -87 -739 -547 -1416 -1064 l-660 -505
                    -386 -775 c-406 -816 -436 -881 -436 -930 0 -63 45 -136 102 -166 71 -37 156
                    -12 467 141 107 52 196 93 199 90 2 -2 8 -921 13 -2042 l8 -2038 33 -29 c18
                    -15 53 -38 78 -50 l45 -21 2860 1 c2817 1 3124 4 3159 33 58 49 1281 1574
                    1565 1953 40 54 78 114 84 135 6 25 11 362 14 978 l4 940 533 535 c292 294
                    553 563 579 598 70 96 70 110 -1 244 -82 155 -287 506 -621 1063 -472 784
                    -562 923 -626 955 -33 16 -539 27 -1405 29 l-435 2 -225 241 c-352 377 -612
                    640 -647 655 -42 17 -109 16 -151 -2z m130 -513 c52 -57 625 -667 1296 -1381
                    l145 -153 -214 -214 -214 -214 -236 0 -237 0 -631 710 c-348 391 -634 717
                    -637 725 -4 9 15 36 47 70 57 57 599 524 611 525 3 0 35 -31 70 -68z m-1099
                    -714 c183 -205 506 -566 716 -803 l382 -430 -1507 -3 c-829 -1 -1509 0 -1512
                    3 -8 8 164 188 649 680 461 468 922 925 932 925 3 0 156 -168 340 -372z
                    m-1423 -145 c-36 -38 -175 -180 -310 -318 -135 -137 -364 -371 -509 -519
                    l-263 -269 -271 7 c-149 3 -275 10 -280 15 -8 8 315 262 1102 865 l374 286
                    111 0 110 0 -64 -67z m4475 -163 l-230 -230 -68 68 c-79 78 -341 360 -345 372
                    -5 14 55 17 473 18 l400 2 -230 -230z m761 -46 c106 -168 864 -1423 871 -1442
                    4 -9 -214 -234 -628 -648 -349 -349 -637 -634 -641 -634 -12 0 -594 960 -877
                    1448 l-83 142 17 28 c32 48 1234 1244 1247 1240 7 -2 50 -62 94 -134z m-1816
                    -3839 l0 -2545 -2750 0 -2750 0 0 1433 c0 1423 15 3475 26 3595 l6 62 2734 0
                    2734 0 0 -2545z m760 1430 c438 -727 476 -785 525 -810 25 -12 61 -19 96 -20
                    49 0 63 5 120 42 l64 43 3 -702 2 -701 -572 -714 c-490 -612 -573 -712 -582
                    -696 -13 22 -16 3991 -3 4067 8 43 10 46 21 30 7 -11 154 -253 326 -539z
                    m-6640 381 c0 -102 -9 -122 -72 -151 -29 -13 -54 -22 -57 -19 -7 6 111 244
                    121 244 4 0 8 -33 8 -74z"
        />
        <path
          d="M3285 4711 c-414 -6 -420 -6 -456 -29 -40 -24 -68 -74 -76 -133 -9
                        -66 5 -108 54 -160 l46 -49 851 1 c468 0 949 4 1068 8 196 6 221 9 245 27 86
                        63 83 222 -5 296 -29 24 -39 26 -174 32 -226 9 -1093 13 -1553 7z"
        />
      </g>
    </svg>
  );
}
